<div class="od-page">

  <!-- ══════════════════════════════
       Hero Header
  ══════════════════════════════ -->
  <div class="od-hero">
    <button class="od-back" (click)="navigateBack()" title="Back to orders">
      <span class="material-symbols-outlined">arrow_back_ios_new</span>
    </button>
    <div class="od-hero-info">
      <p class="od-hero-label">Order #{{ order_id }}</p>
      <h1
        class="od-hero-title od-hero-title--link"
        (click)="goToClient()"
        title="View client"
      >
        {{ clientName }}
      </h1>
    </div>
    <div class="od-hero-badges" *ngFor="let item of order_arr">
      <span class="status-badge" [class.paid]="item.paid" [class.unpaid]="!item.paid">
        <span class="material-symbols-outlined">{{ item.paid ? 'check_circle' : 'schedule' }}</span>
        {{ (item.paid ? 'status.paid' : 'status.unpaid') | translate }}
      </span>
      <span class="status-badge" [class.delivered]="item.delivered" [class.pending]="!item.delivered">
        <span class="material-symbols-outlined">{{ item.delivered ? 'local_shipping' : 'pending' }}</span>
        {{ (item.delivered ? 'status.delivered' : 'status.pending') | translate }}
      </span>
    </div>
  </div>

  <!-- ══════════════════════════════
       Action Bar
  ══════════════════════════════ -->
  <div class="od-action-bar">
    <button (click)="pay()" class="od-btn od-btn--primary">
      <span class="material-symbols-outlined">payments</span>
      {{ 'btn.confirm_payment' | translate }}
    </button>
    <button (click)="delivered()" class="od-btn od-btn--secondary">
      <span class="material-symbols-outlined">local_shipping</span>
      {{ 'btn.confirm_delivery' | translate }}
    </button>
    <button
      (click)="getDataForEditModel()"
      data-bs-toggle="modal"
      data-bs-target="#EditOrder"
      [disabled]="cancelButtonStatus"
      class="od-btn od-btn--edit"
    >
      <span class="material-symbols-outlined">edit</span>
      {{ 'btn.edit_order' | translate }}
    </button>
    <button
      data-bs-toggle="modal"
      data-bs-target="#DeleteCategory"
      [disabled]="cancelButtonStatus"
      class="od-btn od-btn--danger"
    >
      <span class="material-symbols-outlined">cancel</span>
      {{ 'btn.cancel_order' | translate }}
    </button>
  </div>

  <!-- ══════════════════════════════
       Order Info Card
  ══════════════════════════════ -->
  <div class="app-card od-info-card" *ngFor="let item of order_arr">
    <div class="od-card-header">
      <span class="material-symbols-outlined od-card-icon">receipt_long</span>
      <h3 class="od-card-title">{{ 'ord.information' | translate }}</h3>
    </div>
    <div class="od-info-grid">
      <div class="od-info-item">
        <span class="od-info-label">
          <span class="material-symbols-outlined">calendar_today</span>
          {{ 'ord.date_time' | translate }}
        </span>
        <span class="od-info-value">{{ item.issue_date | date : "EEEE, d MMMM y · HH:mm" }}</span>
      </div>
      <div class="od-info-item">
        <span class="od-info-label">
          <span class="material-symbols-outlined">credit_card</span>
          {{ 'ord.payment_method' | translate }}
        </span>
        <span class="od-info-value">{{ (item.cashed ? 'status.cash_on_delivery' : 'status.vodafone_cash') | translate }}</span>
      </div>
      <div class="od-info-item">
        <span class="od-info-label">
          <span class="material-symbols-outlined">location_on</span>
          {{ 'ord.delivery_address' | translate }}
        </span>
        <span class="od-info-value">
          {{ item.address ? (item.address.address + ' — ' + item.address.city) : ('ord.no_address' | translate) }}
        </span>
      </div>
      <div class="od-info-item">
        <span class="od-info-label">
          <span class="material-symbols-outlined">phone</span>
          {{ 'ord.mobile' | translate }}
        </span>
        <span class="od-info-value">{{ orderPhoneNumber || item?.client?.phone_number || '—' }}</span>
      </div>
      <div class="od-info-item">
        <span class="od-info-label">
          <span class="material-symbols-outlined">local_offer</span>
          {{ 'ord.delivery_fees' | translate }}
        </span>
        <span class="od-info-value od-price">{{ item.fees }} <em class="od-currency">LE</em></span>
      </div>
      <div class="od-info-item od-info-item--total">
        <span class="od-info-label">
          <span class="material-symbols-outlined">account_balance_wallet</span>
          {{ 'lbl.total_price' | translate }}
        </span>
        <span class="od-total-price">{{ item.total_price }} <em class="od-currency">LE</em></span>
      </div>
    </div>
  </div>

  <!-- ══════════════════════════════
       Products Section
  ══════════════════════════════ -->
  <div class="od-section" *ngIf="product_arr?.length">
    <div class="od-section-header">
      <span class="material-symbols-outlined">inventory_2</span>
      <h2 class="od-section-title">{{ 'lbl.products' | translate }}</h2>
      <span class="od-section-count">{{ product_arr.length }} item{{ product_arr.length !== 1 ? 's' : '' }}</span>
    </div>
    <div class="app-card od-table-card">
      <table class="od-table">
        <thead>
          <tr>
            <th>#</th>
            <th>{{ 'ord.product_name' | translate }}</th>
            <th>{{ 'ord.price_unit' | translate }}</th>
            <th>{{ 'lbl.quantity' | translate }}</th>
            <th>{{ 'ord.subtotal' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of product_arr; let i = index">
            <td class="od-td-num">{{ i + 1 }}</td>
            <td class="od-td-name">{{ item?.ordersproducts?.name }}</td>
            <td class="od-td-price">{{ item?.price ?? item?.ordersproducts?.price }} <em class="od-currency">LE</em></td>
            <td class="od-td-qty">
              <span class="od-qty-badge">× {{ item?.ammount }}</span>
            </td>
            <td class="od-td-total">
              {{ item?.ammount * (item?.price ?? item?.ordersproducts?.price) }} <em class="od-currency">LE</em>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- ══════════════════════════════
       Packages Section
  ══════════════════════════════ -->
  <div class="od-section" *ngIf="packagesArr?.length">
    <div class="od-section-header">
      <span class="material-symbols-outlined">category</span>
      <h2 class="od-section-title">{{ 'lbl.packages' | translate }}</h2>
      <span class="od-section-count">{{ packagesArr.length }} package{{ packagesArr.length !== 1 ? 's' : '' }}</span>
    </div>
    <div class="od-packages-grid">
      <div class="app-card od-package-card" *ngFor="let item of packagesArr">
        <div class="od-package-header">
          <div>
            <h4 class="od-package-name">{{ item?.orderspackages?.name }}</h4>
            <p class="od-package-date">{{ item?.orderspackages?.issue_date | date : "d MMM y" }}</p>
          </div>
          <div class="od-package-meta">
            <span class="od-qty-badge">× {{ item?.ammount }}</span>
            <span class="od-package-price">
              {{ item?.orderspackages?.total_price * item?.ammount }} <em class="od-currency">LE</em>
            </span>
          </div>
        </div>
        <div class="od-package-products" *ngIf="item?.orderspackages?.ProductPackages?.length">
          <p class="od-package-products-label">{{ 'ord.included_products' | translate }}</p>
          <div class="od-package-product-row" *ngFor="let pack of item?.orderspackages?.ProductPackages">
            <span class="od-package-product-name">{{ pack?.products?.name }}</span>
            <span class="od-package-product-amount">{{ pack?.amount }} unit{{ pack?.amount !== 1 ? 's' : '' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>


<!-- ══════════════════════════════════════
     Cancel Order Modal
══════════════════════════════════════ -->
<div class="modal fade" id="DeleteCategory" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content od-modal-content">
      <div class="od-modal-header od-modal-header--centered">
        <div class="od-modal-icon od-modal-icon--danger">
          <span class="material-symbols-outlined">warning</span>
        </div>
        <h2 class="od-modal-title">{{ 'ord.cancel_title' | translate }}</h2>
        <p class="od-modal-subtitle">{{ 'ord.cancel_sub' | translate }}</p>
      </div>
      <div class="od-modal-footer">
        <button type="button" class="od-btn od-btn--secondary" data-bs-dismiss="modal">
          {{ 'btn.keep_order' | translate }}
        </button>
        <button (click)="DeleteOrder()" type="button" data-bs-dismiss="modal" class="od-btn od-btn--danger">
          <span class="material-symbols-outlined">cancel</span>
          {{ 'btn.yes_cancel' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>


<!-- ══════════════════════════════════════
     Edit Order Modal
══════════════════════════════════════ -->
<div class="modal fade" id="EditOrder" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg">
    <div class="modal-content od-modal-content">

      <div class="od-modal-header od-modal-header--row">
        <h2 class="od-modal-title">{{ 'ord.edit_title' | translate }}</h2>
        <button type="button" class="od-modal-close" data-bs-dismiss="modal" aria-label="Close" (click)="closePrompt()">
          <span class="material-symbols-outlined">close</span>
        </button>
      </div>

      <div class="od-modal-body">

        <!-- Current Products / Packages -->
        <div class="od-edit-section">
          <div class="od-edit-section-head">
            <p class="od-edit-label">
              {{ (orderProductsForEditing?.length > 1 ? 'ord.current_products' : 'ord.current_product') | translate }}
            </p>
            <small class="od-edit-tip">{{ 'ord.remove_tip_pre' | translate }} <strong>0</strong> {{ 'ord.remove_tip_post' | translate }}</small>
          </div>

          <table class="od-edit-table" *ngIf="product_arr?.length" [formGroup]="currentProductForm">
            <thead><tr><th>{{ 'lbl.product' | translate }}</th><th>{{ 'lbl.amount' | translate }}</th></tr></thead>
            <tbody>
              <tr *ngFor="let item of orderProductsForEditing; let i = index">
                <td>{{ item?.ordersproducts?.name }}</td>
                <td>
                  <input
                    [formControl]="currentProductAmountControls[i]"
                    type="number"
                    class="od-edit-input od-edit-input--sm"
                    [value]="item?.ammount"
                    (change)="changeProductAmount(item?.ordersproducts?.id, currentProductAmountControls[i].value)"
                  />
                </td>
              </tr>
            </tbody>
          </table>

          <table class="od-edit-table" *ngIf="packagesArr.length" [formGroup]="currentProductForm">
            <thead><tr><th>{{ 'lbl.package' | translate }}</th><th>{{ 'lbl.amount' | translate }}</th></tr></thead>
            <tbody>
              <tr *ngFor="let item of orderPackagesForEditing; let i = index">
                <td>{{ item?.orderspackages?.name }}</td>
                <td>
                  <input
                    [formControl]="currentPackageAmountControls[i]"
                    type="number"
                    class="od-edit-input od-edit-input--sm"
                    [value]="item?.ammount"
                    (change)="changePackageAmount(item?.orderspackages?.id, currentPackageAmountControls[i].value)"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="od-edit-divider"></div>

        <!-- Add Products -->
        <div class="od-edit-section" *ngIf="packImageStatus">
          <p class="od-edit-label">{{ 'ord.add_products' | translate }}</p>
          <div class="od-edit-row">
            <div class="od-dropdown-wrap">
              <button class="od-dropdown-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ catName || ('btn.choose_category' | translate) }}
                <span class="material-symbols-outlined">expand_more</span>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" (click)="getCatId(item)" *ngFor="let item of cat_arr">{{ item.name }}</a>
                </li>
              </ul>
            </div>

            <div class="od-dropdown-wrap" *ngIf="ifProd">
              <button class="od-dropdown-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ prodName || ('btn.choose_product' | translate) }}
                <span class="material-symbols-outlined">expand_more</span>
              </button>
              <ul class="dropdown-menu">
                <li *ngFor="let item of prod_arr">
                  <a class="dropdown-item" *ngIf="item.quantity > 0" (click)="choseProd(item)">{{ item.name }}</a>
                </li>
              </ul>
            </div>

            <p class="od-edit-empty" *ngIf="status_prod && !ifProd">{{ 'empty.no_cat_products' | translate }}</p>
          </div>

          <div class="od-edit-row" *ngIf="ifProd">
            <div class="od-field-group">
              <label class="od-field-label">{{ 'lbl.quantity' | translate }}</label>
              <input type="number" [(ngModel)]="Quantity" class="od-edit-input" />
            </div>
            <button class="od-btn od-btn--primary" (click)="add()">
              <span class="material-symbols-outlined">add</span>
              {{ 'btn.add_product' | translate }}
            </button>
          </div>

          <table class="od-edit-table" *ngIf="arrayChoiceProduct?.length">
            <thead><tr><th>{{ 'lbl.product' | translate }}</th><th>{{ 'lbl.amount' | translate }}</th></tr></thead>
            <tbody>
              <tr *ngFor="let item of arrayChoiceProduct">
                <td>{{ item?.prodName }}</td>
                <td>{{ item?.amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="od-edit-divider" *ngIf="packImageStatus"></div>

        <!-- Add Packages -->
        <div class="od-edit-section" *ngIf="packImageStatus">
          <p class="od-edit-label">{{ 'ord.add_packages' | translate }}</p>
          <div class="od-edit-row">
            <div class="od-dropdown-wrap">
              <button class="od-dropdown-btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                {{ packageName || ('btn.choose_package' | translate) }}
                <span class="material-symbols-outlined">expand_more</span>
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" (click)="selectPackageFromList(item)" *ngFor="let item of package_arr">
                    {{ item.name }}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="od-edit-row" *ngIf="ifPackage">
            <div class="od-field-group">
              <label class="od-field-label">{{ 'lbl.quantity' | translate }}</label>
              <input type="number" [(ngModel)]="packageQuantity" class="od-edit-input" />
            </div>
            <button class="od-btn od-btn--primary" (click)="addPackage()">
              <span class="material-symbols-outlined">add</span>
              {{ 'btn.add_package' | translate }}
            </button>
          </div>

          <table class="od-edit-table" *ngIf="arrayChoicePackage?.length">
            <thead><tr><th>{{ 'lbl.package' | translate }}</th><th>{{ 'lbl.amount' | translate }}</th></tr></thead>
            <tbody>
              <tr *ngFor="let item of arrayChoicePackage">
                <td>{{ item?.packageName }}</td>
                <td>{{ item?.amount }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="od-edit-divider"></div>

        <!-- Address Section -->
        <div class="od-edit-section">
          <p class="od-edit-label">{{ 'ord.delivery_address' | translate }}</p>
          <div class="od-current-address">
            <span class="od-edit-empty" *ngIf="!orderAddressForEditing">{{ 'ord.no_address_on_order' | translate }}</span>
            <strong *ngIf="orderAddressForEditing">
              {{ orderAddressForEditing?.address + ' — ' + orderAddressForEditing?.city + ', ' + orderAddressForEditing?.governorate }}
            </strong>
          </div>

          <button
            *ngIf="packImageStatus && !showChangingAddress && !showAddingNewAddressForm"
            (click)="changeAddress()"
            class="od-btn od-btn--secondary"
          >
            <span class="material-symbols-outlined">edit_location</span>
            {{ 'btn.change_address' | translate }}
          </button>

          <!-- Address List -->
          <div *ngIf="showChangingAddress && clientAddressForUpdatingAddress" class="od-address-list">
            <div *ngFor="let address of clientAddressForUpdatingAddress" class="od-address-option">
              <input
                type="radio"
                [id]="'addr_' + address.id"
                [value]="address?.id"
                name="address"
                (change)="selectAddress(address?.id)"
              />
              <label [for]="'addr_' + address.id" class="od-address-label">
                <strong>{{ address?.city | titlecase }}</strong>
                <small class="ms-2">{{ address?.governorate }}</small>
                <p>{{ address?.addresss }}</p>
              </label>
            </div>
            <button *ngIf="!showAddingNewAddressForm" (click)="addNewAddress()" class="od-btn od-btn--secondary">
              <span class="material-symbols-outlined">add_location</span>
              {{ 'btn.add_address' | translate }}
            </button>
          </div>

          <!-- New Address Form -->
          <div *ngIf="showAddingNewAddressForm" class="od-address-form" [formGroup]="clientAddress">
            <div class="od-address-form-grid">
              <div class="od-field-group">
                <label class="od-field-label">{{ 'lbl.city' | translate }}</label>
                <input formControlName="city" type="text" class="od-edit-input" />
              </div>
              <div class="od-field-group">
                <label class="od-field-label">{{ 'lbl.governorate' | translate }}</label>
                <input formControlName="governorate" type="text" class="od-edit-input" />
              </div>
            </div>
            <div class="od-field-group">
              <label class="od-field-label">{{ 'lbl.full_address' | translate }}</label>
              <input formControlName="address" type="text" class="od-edit-input" />
            </div>
            <div class="od-address-form-actions">
              <button class="od-btn od-btn--primary" [disabled]="!clientAddress.valid" (click)="saveAddress()">
                <span class="material-symbols-outlined">save</span>
                {{ 'btn.save_address' | translate }}
              </button>
              <button class="od-btn od-btn--secondary" (click)="backToClientAddressList()">
                <span class="material-symbols-outlined">arrow_back</span>
                {{ 'btn.back' | translate }}
              </button>
            </div>
          </div>
        </div>

        <div class="od-edit-divider"></div>

        <!-- Phone Number -->
        <div class="od-edit-section" [formGroup]="phoneNoForm">
          <p class="od-edit-label">{{ 'ord.contact_phone' | translate }}</p>
          <div class="od-field-group">
            <label class="od-field-label">{{ 'lbl.phone_number' | translate }}</label>
            <input formControlName="phoneNumber" type="text" class="od-edit-input" [placeholder]="'ph.phone_eg' | translate" />
            <span class="od-field-error" *ngIf="phoneNoForm.controls.phoneNumber.errors?.['invalidEmailOrPhone']">
              {{ 'err.phone_valid' | translate }}
            </span>
          </div>
        </div>

      </div><!-- /modal-body -->

      <div class="od-modal-footer">
        <button type="button" class="od-btn od-btn--secondary" data-bs-dismiss="modal" (click)="closePrompt()">
          {{ 'btn.close' | translate }}
        </button>
        <button (click)="save()" type="button" data-bs-dismiss="modal" class="od-btn od-btn--primary">
          <span class="material-symbols-outlined">save</span>
          {{ 'btn.save_order' | translate }}
        </button>
      </div>

    </div>
  </div>
</div>
